import type { ApplicationCondition, ApplicationConditionType } from '../types';

export const APPLICATION_CONDITION_LABELS: Record<ApplicationConditionType, string> = {
  LOADING_FAILURE: 'Срыв погрузки',
  UNLOADING_FAILURE: 'Срыв выгрузки',
  LATE_LOADING: 'Опоздание на погрузку',
  LATE_UNLOADING: 'Опоздание на выгрузку',
  DOCUMENTS: 'Оригиналы документов',
  VEHICLE_CHANGE: 'Смена ТС/водителя',
  NO_LOCATION: 'Отсутствие дислокации',
};

export const APPLICATION_CONDITION_OPTIONS = Object.entries(APPLICATION_CONDITION_LABELS).map(([value, label]) => ({
  value: value as ApplicationConditionType,
  label,
}));

export function formatConditionValue(
  value: ApplicationCondition['value'],
  valueType?: ApplicationCondition['valueType'] | ApplicationCondition['calculationType']
): string {
  if (value === null || value === undefined || value === '') return '—';
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  if (valueType === 'percent') return `${n.toLocaleString('ru-RU')}%`;
  return `${n.toLocaleString('ru-RU')} ₽`;
}

export function formatApplicationCondition(condition: ApplicationCondition): { terms: string; amount: string } {
  const type = condition.type;
  if (type === 'LOADING_FAILURE' || type === 'UNLOADING_FAILURE' || type === 'VEHICLE_CHANGE') {
    const amount = formatConditionValue(condition.value, condition.calculationType);
    return { terms: 'Разовый штраф', amount };
  }

  if (type === 'LATE_LOADING' || type === 'LATE_UNLOADING') {
    const threshold = condition.thresholdDays ?? 0;
    const amount = `${formatConditionValue(condition.value, condition.valueType)} / день`;
    return { terms: `> ${threshold} ${dayWord(threshold)} -> штраф за каждый день`, amount };
  }

  if (type === 'DOCUMENTS') {
    const deadline = condition.deadlineDays ?? 0;
    const hasPenalty = condition.value !== null && condition.value !== undefined && condition.value !== '';
    const amount = hasPenalty
      ? `${formatConditionValue(condition.value, condition.valueType || condition.calculationType)}${condition.calculationType === 'per_day' ? ' / день' : ''}`
      : '—';
    return { terms: `Срок: ${deadline} ${dayWord(deadline)}`, amount };
  }

  const amount = `${formatConditionValue(condition.value, 'fixed')} / день (справочно)`;
  return { terms: 'Только для информации', amount };
}

function dayWord(days: number): string {
  const abs = Math.abs(Math.trunc(days));
  const m10 = abs % 10;
  const m100 = abs % 100;
  if (m100 >= 11 && m100 <= 14) return 'дней';
  if (m10 === 1) return 'день';
  if (m10 >= 2 && m10 <= 4) return 'дня';
  return 'дней';
}
